import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .7,
			y: .7,
			width: 13.6,
			height: 12.6,
			rx: 1.3,
			stroke: "#EEEEEE",
			strokeWidth: 1.4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1,
			y1: 2,
			x2: 14,
			y2: 2,
			stroke: "#EEEEEE",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7.7,
			y1: 1,
			x2: 7.7,
			y2: 13,
			stroke: "#EEEEEE",
			strokeWidth: 1.4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14,
			y1: 7.7,
			x2: 1,
			y2: 7.7,
			stroke: "#EEEEEE",
			strokeWidth: 1.4
		})
	]
});
export default SvgCustomize;
